(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("CustomPageMediaBrowserCtrl", ["$scope", "$http", "localizationId", "languageCulture", "pageName", "enabledLocalizations", "pageFilesResource", "Upload", "messageService", "_", customPageMediaBrowserCtrl]);
    function customPageMediaBrowserCtrl($scope, $http, localizationId, languageCulture, pageName, enabledLocalizations, pageFilesResource, Upload, messageService, _) {
        var vm = this;
        vm.loading = true;
        vm.noFiles = false;
        vm.saving = false;
        vm.selectedLocalizationId = localizationId;
        var currentLanguageCulture = languageCulture;
        getFiles(languageCulture);
        function getFiles(langCulture) {
            pageFilesResource.getListOfFiles({ languageCulture: langCulture }, function (data) {
                if (data.length > 0) {
                    vm.files = data;
                    vm.noFiles = false;
                }
                else
                    vm.noFiles = true;
                vm.enabledLocalizations = enabledLocalizations;
                vm.loading = false;
            });
        }
        vm.insertImage = function (imageUrl) {
            $scope.$close(imageUrl);
        };
        vm.upload = function (file, errFiles) {
            if (vm.saving)
                return;
            if (errFiles.length > 0) {
                vm.file = errFiles[0];
                if (vm.file.$error === "maxSize")
                    messageService.error("common.dropzone.fileTooBigMessage");
                else if (vm.file.$error === "pattern")
                    messageService.error("common.dropzone.invalidFileTypeMessage");
                else
                    messageService.error("common.dropzone.generalErrorMessage");
                return;
            }
            if (file) {
                vm.saving = true;
                file.upload = Upload.upload({
                    url: "api/pageFiles/" + currentLanguageCulture + "/" + pageName,
                    data: { file: file }
                });
                file.upload.then(function () {
                    //$scope.$close(response.data);
                    getFiles(languageCulture);
                    messageService.success("common.fileUploaded");
                    vm.saving = false;
                }, function (response) {
                    if (response.status > 0) {
                        var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                        messageService.error(error);
                        vm.saving = false;
                    }
                });
            }
        };
        vm.changeLocalization = function (localizationId, langCulture) {
            if (vm.selectedLocalizationId !== localizationId) {
                currentLanguageCulture = langCulture;
                vm.selectedLocalizationId = localizationId;
                getFiles(langCulture);
            }
        };
        vm.deleteFile = function (file) {
            vm.model = { fileName: file };
            pageFilesResource.deleteFile(vm.model, function () {
                messageService.success("common.fileDeleted");
                vm.files = _.without(vm.files, _.find(vm.files, { fileName: file }));
                vm.noFiles = vm.files.length === 0;
            }, function (errorData) {
                messageService.error(errorData);
            });
        };
    }
}());
